import { Component, OnInit, HostListener } from '@angular/core';

import { Login, Menu } from 'app/core/interfaces/menu';

import { environment } from 'app/environments/environment';
import { menuInstituicao, menuPatient, menuPractitioner, menuSecretary } from 'app/core/data/menu.json';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { userInfo } from 'os';
import { CurrentUser } from '../../core/interfaces/currentUser';

export interface userInfo {
  photo: string,
  name: string
}

@Component({
  selector: 'page-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends BaseComponent implements OnInit {

  public menus: Menu[] =[];
  public login: Login = <Login>{ };

  public activeMenu = false;
  public title = environment.titleSite;
  public linkHome = 'linkHome';
  public user: userInfo = { photo: '', name: '' };

  @HostListener('document:click', ['$event']) onDocumentClick() {
    this.activeMenu = false;        
  }

  ngOnInit() {   
    if (!this.auth.isAuthenticated()) {     
      this.sair();
    }
    this.getMenuUser();
    if (this.currentUser) {
      this.user.photo = this.currentUser.user.photo; //'/assets/fotos/secretaria-2.jpg'; 
      this.user.name = this.currentUser.user.name; 
    }
  }

  public goTo(menu: Menu) {   
    this.router.navigate([menu.page]);    
  }

  public get isAdmin(): boolean {
    return this.auth.isAdmin();
  }

  public get isAuthenticated(): boolean {
    return true;
  }

  public logar() {    
    if (this.login.email && this.login.password) {
        this.auth.login(this.login.email, this.login.password)
            .subscribe(
                () => {
                    this.loading = false;            
                    location.reload();
                }
            );
    } else {
        this.loading = false;     
    }
  }

  public toogleMenu() { 
    this.activeMenu = !this.activeMenu;        
  }  

  public sair() { 
    this.layout.openDialog({
      showButtonCancel: true,
      buttonText: 'Desejo sair',
      title: 'Você realmente deseja sair?',
      content: ' '
    }).subscribe((retorno: any) => {
      if (retorno) {
        this.router.navigate(['login']);
        this.auth.clearLogin();
       
      }
    })          
  }  

  public getMenuUser() {
    this.auth.currentUser;
    this.menus = this.getMenu();
  }

  public getMenu() {
    if (this.currentUser && this.currentUser.user && this.currentUser.type){

      switch(this.currentUser.type){
        case 'organization' : return menuInstituicao;
        case 'practitioner' : return menuPractitioner;
        case 'secretary' : return menuSecretary;
        default : return menuPatient;
      }
      
    }  
    return menuPractitioner;    
  }
  
}
